var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "b-card",
    { attrs: { "no-body": "", "border-variant": _vm.selected ? "brand" : "" } },
    [
      _c("b-card-header", { staticClass: "aspect-1-1 bg-white" }, [
        _c("div", { staticClass: "aspect-box" }, [
          _c("img", {
            staticClass: "p-1 frame-image",
            attrs: { src: _vm.imgSrc, alt: _vm.altText },
          }),
        ]),
      ]),
      _c("b-card-body", { staticClass: "p-2" }, [
        _c("p", { staticClass: "tag green" }, [
          _vm._v("From £" + _vm._s(_vm.fromPrice) + " each"),
        ]),
        _c("p", { staticClass: "card-text text-center" }, [
          _vm._v(_vm._s(_vm.description)),
        ]),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }